import { V2Button, V2Tooltip } from "@stacklet/ui";

/**
 * Action bar for the Identity Providers settings page. Adding a provider from
 * the console is not implemented yet, so the action is disabled with an
 * explanatory tooltip.
 */
export function IdentityProvidersActionBar() {
  return (
    <div className="mb-xl flex items-center justify-end">
      <V2Tooltip
        title="Adding an identity provider is not available yet"
        asChild
      >
        <span>
          <V2Button variant="secondary" isDisabled>
            Add Identity Provider
          </V2Button>
        </span>
      </V2Tooltip>
    </div>
  );
}
